import React from 'react'
import { getDisplayName } from 'recompose'
import { ApolloProvider } from '@apollo/client'

import apollo from './apollo'

export default ComposedComponent =>
  class WithData extends React.Component {
    static displayName = `WithData(${getDisplayName(ComposedComponent)})`

    constructor(props) {
      super(props)
      this.apollo = apollo()
    }

    render() {
      return (
        <ApolloProvider client={this.apollo}>
          <ComposedComponent {...this.props} />
        </ApolloProvider>
      )
    }
  }
